import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideos"><Path d="M20 3H4V5H20V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 6H2V21H22V6ZM14.6667 13.5L10 10V17L14.6667 13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideos;
